<div class="wrapper">
  <div class="header">
    <h2 class="mat-title">Аналоги {{ product?.brand?.description }} {{ product?.article }}</h2>
    <div class="action">
      <button mat-icon-button (click)="openDialog()">
        <mat-icon>add</mat-icon>
      </button>
    </div>
  </div>
  <div class="body">
    <app-product-table
      [products]="product ? (product.analogies ? product.analogies : []) : []"
      [columnsToDisplay]="columnsToDisplay"
      [loading]="loading"
      (removeEvent)="removeAnalogue($event)"
      [loadingProducts]="loadingProducts"
    ></app-product-table>
  </div>
</div>
